import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./HospitalStats.css";

const HospitalStats = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" });
  }, []);

  const stats = [
    {
      id: 1,
      value: "5+",
      label: "Years of Experience",
      icon: "./images/hospitalRating/hospitalRating.webp",
      animation: "fade-up",
    },
    {
      id: 2,
      value: "1000+",
      label: "Successful Patients Treated",
      icon: "./images/hospitalRating/patients.webp",
      animation: "fade-up",
    },
    {
      id: 3,
      value: "100%",
      label: "Patient Satisfaction",
      icon: "./images/hospitalRating/satisfaction.webp",
      animation: "fade-up",
    },
    {
      id: 4,
      value: "24×7",
      label: "Emergency Support",
      icon: "./images/hospitalRating/emergency.webp",
      animation: "fade-up",
    },
  ];

  return (
    <section className="stats-section">
      <div className="stats-container">
        {stats.map((item, index) => (
          <div
            className="stat-card"
            key={item.id}
            data-aos={item.animation}
            data-aos-delay={index * 150}
          >
            <img src={item.icon} alt={item.label} className="stat-icon" />
            <h2 className="stat-value">{item.value}</h2>
            <p className="stat-label">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HospitalStats;
